import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import AnalysisModule from '../components/AnalysisModule';
import History from '../components/History';
import { initFirebase, saveAnalysis, subscribeToHistory } from '../firebase';

const Mackinder05 = () => {
  const [userId, setUserId] = useState(null);
  const [authStatus, setAuthStatus] = useState('Cargando autenticación...');
  const [analyses, setAnalyses] = useState([]);

  useEffect(() => {
    const init = async () => {
      const uid = await initFirebase();
      if (uid) {
        setUserId(uid);
        setAuthStatus(`✅ Conectado`);
        
        const unsubscribe = subscribeToHistory(uid, (data) => {
          setAnalyses(data);
        });
        
        return () => unsubscribe();
      } else {
        setAuthStatus('⚠️ No hay usuario autenticado');
      }
    };
    
    init();
  }, []);

  const handleSave = (query, result, type) => {
    if (userId) {
      saveAnalysis(userId, query, result, type);
    }
  };

  return (
    <div className="container">
      <Header 
        title="Mackinder - Parte 5" 
        subtitle="Futuro de la Geopolítica del Heartland"
        authStatus={authStatus}
      />

      <section className="card" style={{ marginBottom: '2rem', textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#004e92', marginBottom: '1rem' }}>
          El Heartland en el Siglo XXI
        </h2>
        <p style={{ lineHeight: '1.7', maxWidth: '800px', margin: '0 auto' }}>
          ¿Sigue siendo relevante la teoría de Mackinder en un mundo de tecnología avanzada, cambio climático y nuevos actores globales?
        </p>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', textAlign: 'center', marginBottom: '2rem', color: '#004e92' }}>
          Factores que Desafían la Teoría
        </h3>
        <div className="grid">
          <div className="card" style={{ borderTop: '4px solid #ef4444' }}>
            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#ef4444' }}>
              ✈️ Poder Aéreo y Espacial
            </h3>
            <p style={{ lineHeight: '1.7', marginBottom: '1rem' }}>
              La tecnología moderna ha reducido la importancia de la geografía:
            </p>
            <ul style={{ marginLeft: '1.5rem', lineHeight: '1.8' }}>
              <li><strong>Misiles intercontinentales:</strong> Pueden alcanzar cualquier punto del planeta</li>
              <li><strong>Drones y satélites:</strong> Vigilancia global sin presencia física</li>
              <li><strong>Ciberespacio:</strong> Un nuevo dominio sin geografía física</li>
              <li><strong>Armas nucleares:</strong> Hacen irrelevante el control territorial</li>
            </ul>
          </div>

          <div className="card" style={{ borderTop: '4px solid #3b82f6' }}>
            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#3b82f6' }}>
              🌡️ Cambio Climático
            </h3>
            <p style={{ lineHeight: '1.7', marginBottom: '1rem' }}>
              El calentamiento global está transformando el Heartland:
            </p>
            <ul style={{ marginLeft: '1.5rem', lineHeight: '1.8' }}>
              <li><strong>Ártico navegable:</strong> Nuevas rutas marítimas en el norte de Rusia</li>
              <li><strong>Deshielo de Siberia:</strong> Acceso a recursos antes inaccesibles</li>
              <li><strong>Agricultura en expansión:</strong> Tierras cultivables en el norte</li>
              <li><strong>Nuevas disputas:</strong> Control del Ártico como zona estratégica</li>
            </ul>
          </div>

          <div className="card" style={{ borderTop: '4px solid #8b5cf6' }}>
            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#8b5cf6' }}>
              🌐 Globalización
            </h3>
            <p style={{ lineHeight: '1.7', marginBottom: '1rem' }}>
              La economía global ha cambiado las reglas:
            </p>
            <ul style={{ marginLeft: '1.5rem', lineHeight: '1.8' }}>
              <li><strong>Interdependencia económica:</strong> El comercio es más importante que el territorio</li>
              <li><strong>Cadenas de suministro:</strong> Ningún país es autosuficiente</li>
              <li><strong>Poder económico:</strong> China domina sin controlar el Heartland</li>
              <li><strong>Tecnología sobre recursos:</strong> La innovación supera a los recursos naturales</li>
            </ul>
          </div>
        </div>
      </section>

      <section style={{ marginBottom: '2rem' }}>
        <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', textAlign: 'center', marginBottom: '2rem', color: '#004e92' }}>
          Factores que Validan la Teoría
        </h3>
        <div className="grid">
          <div className="card" style={{ borderTop: '4px solid #22c55e' }}>
            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#22c55e' }}>
              🇷🇺 Resurgimiento Ruso
            </h3>
            <p style={{ lineHeight: '1.7', marginBottom: '1rem' }}>
              Rusia sigue actuando como si Mackinder tuviera razón:
            </p>
            <ul style={{ marginLeft: '1.5rem', lineHeight: '1.8' }}>
              <li>Conflictos en Georgia, Ucrania, Siria</li>
              <li>Defensa del "extranjero cercano"</li>
              <li>Oposición a la expansión de la OTAN</li>
              <li>Control de recursos energéticos</li>
            </ul>
          </div>

          <div className="card" style={{ borderTop: '4px solid #22c55e' }}>
            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#22c55e' }}>
              🇨🇳 Nueva Ruta de la Seda
            </h3>
            <p style={{ lineHeight: '1.7', marginBottom: '1rem' }}>
              China está construyendo infraestructura terrestre en Eurasia:
            </p>
            <ul style={{ marginLeft: '1.5rem', lineHeight: '1.8' }}>
              <li>Belt and Road Initiative (BRI)</li>
              <li>Ferrocarriles a través de Asia Central</li>
              <li>Puertos en el Rimland</li>
              <li>Integración económica de Eurasia</li>
            </ul>
          </div>

          <div className="card" style={{ borderTop: '4px solid #22c55e' }}>
            <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#22c55e' }}>
              ⚡ Recursos Naturales
            </h3>
            <p style={{ lineHeight: '1.7', marginBottom: '1rem' }}>
              El Heartland sigue siendo rico en recursos:
            </p>
            <ul style={{ marginLeft: '1.5rem', lineHeight: '1.8' }}>
              <li>Gas natural y petróleo</li>
              <li>Minerales raros para tecnología</li>
              <li>Tierras cultivables</li>
              <li>Agua dulce</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="card" style={{ marginBottom: '2rem' }}>
        <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem', color: '#004e92', textAlign: 'center' }}>
          🔮 Conclusión: ¿Sigue Vigente Mackinder?
        </h3>
        <div style={{ padding: '1.5rem', backgroundColor: 'rgba(59, 130, 246, 0.1)', borderRadius: '0.75rem', borderLeft: '4px solid #3b82f6' }}>
          <p style={{ lineHeight: '1.8', marginBottom: '1rem' }}>
            <strong>Respuesta:</strong> Parcialmente. La geografía sigue importando, pero ya no es determinante.
          </p>
          <ul style={{ marginLeft: '1.5rem', lineHeight: '1.8' }}>
            <li>✅ Europa del Este sigue siendo un punto de fricción</li>
            <li>✅ El control de recursos naturales sigue siendo importante</li>
            <li>⚠️ Pero la tecnología, economía y poder blando son igualmente cruciales</li>
            <li>⚠️ El poder ya no se mide solo en territorio controlado</li>
          </ul>
          <p style={{ marginTop: '1rem', fontStyle: 'italic', color: '#94a3b8' }}>
            💡 Mackinder tenía razón sobre la importancia de Eurasia, pero subestimó el poder de la tecnología y la economía global.
          </p>
        </div>
      </section>

      <AnalysisModule
        title="✨ Análisis Prospectivo"
        description="Explore el futuro de la teoría del Heartland."
        inputType="textarea"
        systemPrompt="Actúa como un futurista geopolítico. Analiza cómo la Teoría del Heartland de Mackinder podría evolucionar o perder relevancia en las próximas décadas. Considera factores como cambio climático, tecnología, espacio, y nuevos actores globales. Responde en español de forma concisa."
        onSave={handleSave}
        type="section"
      />

      <History analyses={analyses} />

      <div style={{ position: 'fixed', bottom: '20px', right: '20px', display: 'flex', gap: '10px', zIndex: 1000 }}>
        <Link to="/mackspyman04" className="btn btn-primary" style={{ textDecoration: 'none' }}>
          ⬅️ Anterior
        </Link>
        <Link to="/" className="btn btn-primary" style={{ textDecoration: 'none' }}>
          🏠 Inicio
        </Link>
        <Link to="/spykman" className="btn btn-primary" style={{ textDecoration: 'none' }}>
          Siguiente ➡️
        </Link>
      </div>
    </div>
  );
};

export default Mackinder05;
